import { c as _c } from "react/compiler-runtime";
import type { Entry, UnresolvedLink } from "contentful";
import { getEntryOfContentType, isEntry } from "@/lib/contentful/guards";
import type { TypeEmailFormSkeleton, TypeImageSkeleton, TypeProseSkeleton } from "@/types/contentful/generated";
import { ContentfulHelper } from "@/utils/ContentfulHelper";
import { EmailForm } from "./EmailForm/EmailForm";
import { Prose } from "./Prose";
import { SingleImage } from "./SingleImage";
type EmailFormEntry = Entry<TypeEmailFormSkeleton, undefined, string>;
type ProseEntry = Entry<TypeProseSkeleton, undefined, string>;
type ImageEntry = Entry<TypeImageSkeleton, undefined, string>;
type ResolvedBlock = Entry<TypeEmailFormSkeleton | TypeImageSkeleton | TypeProseSkeleton, undefined, string>;
type ColumnBlock = ResolvedBlock | UnresolvedLink<"Entry">;
interface Props {
  leftContent: ColumnBlock;
  rightContent: ColumnBlock;
}
function DuplexColumn(t0) {
  const $ = _c(13);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item) {
    t1 = getEntryOfContentType(item, "emailForm");
    $[0] = item;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const emailForm = t1;
  if (emailForm) {
    let t2;
    if ($[2] !== emailForm.fields) {
      t2 = <EmailForm {...emailForm.fields} />;
      $[2] = emailForm.fields;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== item) {
    t2 = getEntryOfContentType(item, "prose");
    $[4] = item;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const proseEntry = t2;
  if (proseEntry) {
    let t3;
    if ($[6] !== proseEntry.fields.content) {
      t3 = <Prose content={proseEntry.fields.content} />;
      $[6] = proseEntry.fields.content;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  let t3;
  if ($[8] !== item) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const imageEntry = getEntryOfContentType(item, "image");
      if (imageEntry) {
        const img = ContentfulHelper.parseContentfulContentImage(imageEntry.fields.media);
        if (!img) {
          t3 = null;
          break bb0;
        }
        let t4;
        if ($[10] !== imageEntry || $[11] !== img) {
          t4 = <SingleImage image={img} entryId={imageEntry.sys.id} />;
          $[10] = imageEntry;
          $[11] = img;
          $[12] = t4;
        } else {
          t4 = $[12];
        }
        t3 = t4;
        break bb0;
      }
    }
    $[8] = item;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  return null;
}
export default function Duplex(t0) {
  const $ = _c(11);
  const {
    leftContent,
    rightContent
  } = t0;
  const left = leftContent && isEntry(leftContent) ? leftContent as ResolvedBlock : null;
  const right = rightContent && isEntry(rightContent) ? rightContent as ResolvedBlock : null;
  if (!left && !right) {
    return null;
  }
  let t1;
  if ($[0] !== left) {
    t1 = left && <DuplexColumn item={left} />;
    $[0] = left;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div>{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== right) {
    t3 = right && <DuplexColumn item={right} />;
    $[4] = right;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div>{t3}</div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-6 w-full max-w-site-content mx-auto">{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}